export default __webpack_public_path__ + "static/media/3.5a6f5a91.png";